import React, { Component } from 'react';
import { titleize } from 'underscore.string';
import _ from 'underscore';
import StripeAccountsStore from 'stores/StripeAccountsStore';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import CargomaticModal from 'components/v2/modal';
import { withTranslation, Translation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import PaymentTerms from 'components/modules/user/shipper/billingv2/PaymentTerms';
import { updateCarrier } from 'utils/CustomersAPIUtils';
import { REGIONS } from 'constants/Regions';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import FileDownload from './FileDownload';
import CustomersActionCreators from '../../../actions/CustomersActionCreators';
import Alert from '../../ui/Alert';
import Badge from '../../v2/Badge';
import CargomaticInput from '../../v2/input';
import CargomaticCard from '../../v2/card';
import CargomaticRadio from '../../v2/forms/Radio';
import LibraryIcon from '../../v2/icons/LibraryIcon';
import SessionStore from '../../../stores/SessionStore';
import CustomerDetailsStore from '../../../stores/CustomerDetailsStore';
import ToastStore, { showToast } from '../../../stores/ToastStore';
import Months from '../../../constants/Months';
import { ACCESSORIAL_PDFS } from '../../../constants/pdf';
import businessTypes from '../../../constants/BusinessTypes';
import stripeVerificationStatus from '../../../constants/stripe';
import Sidebar from './Sidebar';
import Container from '../../v2/container';
import { createBankAccount, uploadSensitiveDocuments, } from '../../../utils/CustomersAPIUtils';
import ErrorLabel from '../../v2/forms/ErrorLabel';
import PDFViewer from '../shipments/PDFViewer';
import { isPDF } from '../../../utils/documents';
import { BILLING_FILE_TYPES } from '../../../config/accepted-file-types';
const hasOwnProperty = Object.prototype.hasOwnProperty;
function renderAccessorialDownloads() {
    const user = SessionStore.getUser();
    const type = user._type.toLowerCase();
    const pdfUrl = ACCESSORIAL_PDFS[type];
    return (React.createElement(FileDownload, { fileUrl: pdfUrl },
        React.createElement(Translation, null, (t) => React.createElement("span", null, t('VIEW_ACCESSORIAL_DEF_CHARGES')))));
}
function getInitialState() {
    return {
        stripe_verification: {
            status: '',
        },
        bankAccount: {
            id: null,
            bank_name: '',
            last4: '',
        },
        routing: '',
        account: '',
        first_name: '',
        last_name: '',
        name: '',
        month: '',
        day: '',
        year: '',
        personal_id_number: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        postal_code: '',
        bank: '',
        ending4Digits: '',
        business_type: 'individual',
        business_name: '',
        business_tax_id: '',
        maxDay: 31,
        maxYear: new Date().getFullYear(),
        errors: {},
        successMessage: '',
        showBankForm: false,
        business_tax_id_provided: false,
        personal_id_number_provided: false,
        is_partner_with_factoring_company: false,
        factoring_company_name: '',
        sensitive_documents: [],
        admin_banking_info_remark: '',
        showPreviewModal: false,
        previewFiles: [],
        currentDocumentType: '',
        showThankingModal: false,
    };
}
const CompanyTooltip = (React.createElement(Tooltip, { id: "tooltip-company-required-details" },
    React.createElement(Translation, null, (t) => React.createElement(React.Fragment, null, t('BUSINESS_TYPE_COMPANY_TOOLTIP')))));
const IndividualTooltip = (React.createElement(Tooltip, { id: "tooltip-individual-required-details" },
    React.createElement(Translation, null, (t) => React.createElement(React.Fragment, null, t('BUSINESS_TYPE_INDIVIDUAL_TOOLTIP')))));
class Billing extends Component {
    constructor(props) {
        super(props);
        this.getHandleChange = (field) => (value) => {
            this.setState({ [field]: value });
        };
        this.handleReceiveCustomer = () => {
            const user = CustomerDetailsStore.getDetails();
            if (!user) {
                return;
            }
            let profile = _.pick(user, 'sensitive_documents', 'is_partner_with_factoring_company', 'factoring_company_name', 'all_banking_info_approved', 'admin_banking_info_remark');
            if (user.stripe_legal_entity) {
                const { stripe_legal_entity: { first_name, last_name, dob: { month, day, year }, personal_id_number_provided, business_tax_id_provided, business_name, }, } = user;
                profile = Object.assign(Object.assign({}, profile), { first_name,
                    last_name,
                    month,
                    day,
                    year,
                    personal_id_number_provided,
                    business_tax_id_provided,
                    business_name });
            }
            if (user.stripe_verification) {
                const stripe_verification = _.omit(user.stripe_verification, [
                    'requirements',
                ]);
                profile = Object.assign(Object.assign({}, profile), { stripe_verification });
            }
            if (Object.keys(profile).length > 0) {
                this.setState(Object.assign({}, profile));
            }
        };
        this.handleReceiveStripeInfo = () => {
            const accountInfo = StripeAccountsStore.getAccountInfo();
            if (!accountInfo || _.isEmpty(accountInfo))
                return;
            const { address: { city, state, line1, line2, postal_code }, business_profile: { name: business_name }, dob, first_name, last_name, business_type, verification: stripe_verification, } = accountInfo;
            const bankAccount = (accountInfo.external_accounts || [])[0] || {
                id: null,
                bank_name: '',
                last4: '',
            };
            this.setState({
                bankAccount,
                city,
                state,
                line1,
                line2,
                postal_code,
                business_name,
                day: (dob && dob.day) || '',
                month: (dob && dob.month) || '',
                year: (dob && dob.year) || '',
                first_name,
                last_name,
                business_type,
                stripe_verification,
            });
        };
        this.handleNotifications = () => {
            const toast = ToastStore.getLatestNotification();
            if (toast && toast.level === 'error') {
                this.setState((prevState) => {
                    const errors = Object.assign(Object.assign({}, prevState.errors), { bankAccount: toast.title });
                    return { errors };
                });
            }
            else if (toast && toast.level === 'success') {
                this.setState({
                    successMessage: toast.title,
                });
            }
        };
        this.handleEINChange = (business_tax_id) => {
            if (business_tax_id) {
                this.setState({
                    business_tax_id,
                    business_type: businessTypes.COMPANY,
                });
            }
            else {
                this.setState({
                    business_tax_id,
                    business_type: businessTypes.INDIVIDUAL,
                });
            }
        };
        this.handleSubmit = async () => {
            try {
                const errors = this.validate();
                if (Object.keys(errors).length === 0) {
                    const data = this.getRequestData();
                    // create bank account
                    if (this.isPendingOrVerified()) {
                        // Prior we were calling update Bank Account.
                        // That requires a token and these seems to work just fine?
                        await createBankAccount(data);
                    }
                    else {
                        await createBankAccount(data);
                    }
                    this.setState({ showThankingModal: true });
                    this.getCustomer();
                }
            }
            catch (e) {
                console.error(e);
            }
        };
        this.state = getInitialState();
    }
    componentDidMount() {
        this.getCustomer();
        ToastStore.addChangeListener(this.handleNotifications);
        CustomerDetailsStore.addChangeListener(this.handleReceiveCustomer);
        StripeAccountsStore.addChangeListener(this.handleReceiveStripeInfo);
    }
    componentWillUnmount() {
        ToastStore.removeChangeListener(this.handleNotifications);
        CustomerDetailsStore.removeChangeListener(this.handleReceiveCustomer);
        StripeAccountsStore.removeChangeListener(this.handleReceiveStripeInfo);
    }
    getCustomer() {
        const user = SessionStore.getUser();
        if (user) {
            CustomersActionCreators.getCustomer(user._id, false);
            CustomersActionCreators.getBankAccounts(user._id);
        }
    }
    getValidationState(field) {
        if (hasOwnProperty.call(this.state.errors, field)) {
            return 'error';
        }
        return null;
    }
    getRequestData() {
        const { routing, account, bankAccount } = this.state;
        const legal_entity = this.extractLegalEntity();
        const hasExistingBankAccount = bankAccount && bankAccount.id;
        // create bank account
        const data = {
            legal_entity,
            userId: SessionStore.getUser()._id,
            bank_account_id: hasExistingBankAccount ? bankAccount.id : null,
        };
        if (routing && account) {
            data.routing = routing;
            data.account = account;
        }
        return data;
    }
    getPaymentTermsData() {
        const user = SessionStore.getUser();
        const { drayage_payment_method, drayage_terms, shorthaul_payment_method, shorthaul_terms, stripe_customer_id, } = user;
        return {
            drayage_payment_method,
            drayage_terms,
            shorthaul_payment_method,
            shorthaul_terms,
            hasCreditCardOnFile: !!stripe_customer_id,
        };
    }
    // update carrier
    async onSaveCarrier(updates = {}) {
        const user = SessionStore.getUser();
        const payload = Object.assign({ _id: user._id }, updates);
        await updateCarrier(user._id, payload);
    }
    handleDocumentUpload(currentDocumentType) {
        return (files) => {
            this.setState((prev) => ({
                showPreviewModal: true,
                previewFiles: files,
                currentDocumentType,
            }));
        };
    }
    handleHidePreviewConfirmationModal() {
        this.setState({ showPreviewModal: false });
    }
    handleHideThankingModal() {
        this.setState({ showThankingModal: false });
    }
    async handleDocumentSave() {
        const { t } = this.props;
        try {
            const user = SessionStore.getUser();
            const data = await uploadSensitiveDocuments(this.state.previewFiles, user._id, this.state.currentDocumentType);
            this.setState({
                showPreviewModal: false,
                sensitive_documents: data.sensitive_documents,
            }, () => {
                this.getCustomer();
            });
            showToast(t('DOCUMENT_UPLOADED_SUCCESSFULLY'), t('DOCUMENT_UPLOADED_SUCCESSFULLY'), 'success');
        }
        catch (e) {
            console.error(e);
            this.setState({ showPreviewModal: false });
            showToast(t('UPLOAD_DOCUMENT_FAILED'), t('DOCUMENT_UPLOAD_FAILED_RETRY'), 'error');
        }
    }
    getBankAccountVerificationStatus() {
        const { sensitive_documents, all_banking_info_approved, admin_banking_info_remark, } = this.state;
        if ((typeof all_banking_info_approved === 'undefined' &&
            !sensitive_documents.length) ||
            (!all_banking_info_approved &&
                (!admin_banking_info_remark || !admin_banking_info_remark.length) &&
                !sensitive_documents.length))
            return;
        if (all_banking_info_approved) {
            return {
                bankAccountVerificationStatus: 'Verified',
                bankAccountVerified: true,
                remark: '',
            };
        }
        if ((typeof all_banking_info_approved !== 'undefined' ||
            all_banking_info_approved !== null) &&
            all_banking_info_approved === false) {
            return {
                bankAccountVerificationStatus: 'Declined',
                bankAccountVerified: false,
                remark: admin_banking_info_remark,
            };
        }
        const allActiveDocs = (sensitive_documents || []).filter((doc) => doc.active);
        const consolidatedRemark = allActiveDocs
            .filter((doc) => {
            return (doc.status === 'Rejected' &&
                doc.rejectReason &&
                doc.rejectReason.length);
        })
            .map((doc) => doc.rejectReason)
            .join(', ');
        if (consolidatedRemark.length > 0) {
            return {
                bankAccountVerificationStatus: 'Declined',
                bankAccountVerified: false,
                remark: consolidatedRemark,
            };
        }
        return {
            bankAccountVerificationStatus: 'Internal Review',
            bankAccountVerified: false,
        };
    }
    hasBankAccountEntry() {
        const { id } = this.state.bankAccount;
        return id && id.length > 0;
    }
    hasBankAccount() {
        const { bankAccount, all_banking_info_approved } = this.state;
        const { id } = bankAccount;
        return all_banking_info_approved && id && id.length > 0;
    }
    isPendingOrVerified() {
        return this.isPending() || this.isVerified();
    }
    isPending() {
        const { stripe_verification: { status: verificationStatus }, } = this.state;
        return verificationStatus === stripeVerificationStatus.PENDING;
    }
    isVerified() {
        const { stripe_verification: { status: verificationStatus }, } = this.state;
        return verificationStatus === stripeVerificationStatus.VERIFIED;
    }
    extractLegalEntity() {
        const { first_name, last_name, month, day, year, personal_id_number, business_name, business_tax_id, line1, line2, city, state, postal_code, is_partner_with_factoring_company, factoring_company_name, } = this.state;
        let { business_type } = this.state;
        if (business_tax_id && business_tax_id.length) {
            business_type = businessTypes.COMPANY;
        }
        const legalEntity = {
            business_type,
            first_name,
            last_name,
            personal_id_number,
            dob: {
                month,
                day,
                year,
            },
            address: {
                line1,
                line2,
                city,
                state,
                postal_code,
            },
            is_partner_with_factoring_company,
        };
        if (is_partner_with_factoring_company) {
            legalEntity.factoring_company_name = factoring_company_name;
        }
        if (business_type === businessTypes.COMPANY) {
            legalEntity.business_name = business_name;
            legalEntity.business_tax_id = business_tax_id;
        }
        return legalEntity;
    }
    checkIsDocumentUploaded(document_type) {
        const { sensitive_documents } = this.state;
        return ((sensitive_documents || []).filter((doc) => doc.active === true && doc.document_type === document_type).length > 0);
    }
    checkIsActiveDocumentRejected(document_type) {
        const { sensitive_documents } = this.state;
        const doc = (sensitive_documents || []).find((doc) => doc.active === true && doc.document_type === document_type);
        if (!doc || (doc && doc.status !== 'Rejected'))
            return '';
        if (doc && doc.status === 'Rejected')
            return doc.rejectReason || 'Rejected';
    }
    validate() {
        const errors = {};
        const { t } = this.props;
        const { routing, account, first_name, last_name, business_tax_id, personal_id_number, line1, city, state, postal_code, business_type, month, day, year, business_name, personal_id_number_provided, business_tax_id_provided, is_partner_with_factoring_company, factoring_company_name, } = this.state;
        if (!this.isPendingOrVerified()) {
            if (!routing) {
                errors.routing = t('ROUTING_NUMBER_REQUIRED');
            }
            if (!account) {
                errors.account = t('ACCOUNT_NUMBER_REQUIRED');
            }
            if (!this.checkIsDocumentUploaded('w9')) {
                errors.w9 = t('W9_DOCUMENT_REQUIRED');
            }
            if (!this.checkIsDocumentUploaded('voided_check')) {
                errors.voided_check = t('VOIDED_CHECK_OR_BANKS_LETTER_REQUIRED');
            }
            if (is_partner_with_factoring_company &&
                !this.checkIsDocumentUploaded('notice_of_assignment')) {
                errors.notice_of_assignment = t('ASSIGNMENT_NOTICE_REQUIRED');
            }
        }
        if (!first_name) {
            errors.first_name = t('FIRST_NAME_REQUIRED');
        }
        if (!last_name) {
            errors.last_name = t('LAST_NAME_REQUIRED');
        }
        if (!month) {
            errors.month = t('DOB_MONTH_REQUIRED');
        }
        if (!day) {
            errors.day = t('DOB_DAY_REQUIRED');
        }
        if (!year) {
            errors.year = t('DOB_YEAR_REQUIRED');
        }
        if (!business_type) {
            errors.business_type = t('BUSINESS_TYPE_REQUIRED');
        }
        if (is_partner_with_factoring_company &&
            (!factoring_company_name || !factoring_company_name.length)) {
            errors.factoring_company_name = t('FACTORING_COMPANY_NAME_REQUIRED');
        }
        const personalIdNumberRequired = business_type === businessTypes.INDIVIDUAL &&
            !personal_id_number_provided;
        const businessTaxIdRequired = businessTypes === businessTypes.COMPANY && !business_tax_id_provided;
        const filteredSSN = personal_id_number.trim().replace(/-/g, '');
        const ssnLength = filteredSSN.length;
        if (personalIdNumberRequired && ssnLength !== 9) {
            errors.personal_id_number = t('VALID_SSN_REQUIRED');
        }
        if (business_type === businessTypes.COMPANY) {
            if (!business_name) {
                errors.business_name = t('BUSINESS_NAME_REQUIRED');
            }
            const filteredEIN = business_tax_id.trim().replace(/-/g, '');
            const einLength = filteredEIN.length;
            if (businessTaxIdRequired && einLength !== 9) {
                errors.business_tax_id = t('VALID_EIN_REQUIRED');
            }
        }
        if (this.isPendingOrVerified()) {
            if (!line1) {
                errors.line1 = t('STREET_LINE1_REQUIRED');
            }
            if (!city) {
                errors.city = t('CITY_REQUIRED');
            }
            if (!state) {
                errors.state = t('STATE_REQUIRED');
            }
            if (!postal_code) {
                errors.postal_code = t('POSTAL_CODE_REQUIRED');
            }
        }
        this.setState({
            errors,
            successMessage: '',
        });
        return errors;
    }
    renderSuccessMessage() {
        if (this.state.successMessage) {
            return React.createElement(Alert, { type: "success" }, this.state.successMessage);
        }
        return null;
    }
    renderErrors() {
        const errorKeys = Object.keys(this.state.errors);
        if (errorKeys.length > 0) {
            return (React.createElement(Alert, { type: "error" },
                React.createElement("ul", null, errorKeys.map((errorKey, i) => (React.createElement("li", { key: i }, this.state.errors[errorKey]))))));
        }
        return null;
    }
    renderBankInfoSummary() {
        const shouldShowBankAccountInfo = this.hasBankAccountEntry();
        const { t } = this.props;
        if (shouldShowBankAccountInfo) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "mb-4" },
                    React.createElement("h4", { className: "my-0 mb-4" }, t('BANK_ACCOUNT_ON_FILE')),
                    React.createElement("div", { className: "flex space-x-4" },
                        React.createElement("div", { className: "flex items-center space-x-2" },
                            React.createElement("div", { className: "flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full" },
                                React.createElement(LibraryIcon, null)),
                            React.createElement("p", null,
                                React.createElement("span", { className: "block" }, this.state.bankAccount.bank_name),
                                React.createElement("small", { className: "block text-sm italic" }, t('ACCOUNT_NUMBER_ENDING_IN', {
                                    last4: this.state.bankAccount.last4,
                                })))))),
                React.createElement("div", { className: "mt-4 actions items-center" },
                    React.createElement("a", { href: `mailto:${BANKING_INFO_UPDATE_CONTACT_EMAIL_ID}?&subject=I'd like to modify my banking information`, target: "_blank", rel: "noreferrer" }, t('MODIFY_YOUR_BANKING_INFO')))));
        }
        return React.createElement("h4", { className: "my-0" }, t('NO_BANK_ACCOUNT_ON_FILE'));
    }
    renderBankingHeader() {
        const verificationDetails = this.getBankAccountVerificationStatus();
        const { t } = this.props;
        if (typeof verificationDetails === 'undefined')
            return null;
        const { bankAccountVerificationStatus, bankAccountVerified, remark } = verificationDetails;
        return (React.createElement("div", { className: "mt-8" },
            React.createElement("h3", { className: "my-0" }, t('BANK_INFORMATION')),
            bankAccountVerificationStatus && (React.createElement(React.Fragment, null,
                React.createElement("p", null, t('BANKING_INFO_SUBMITTED')),
                React.createElement("div", { className: "flex gap-4" },
                    React.createElement("p", null,
                        t('STATUS'),
                        ":"),
                    React.createElement(Badge, { color: bankAccountVerified ? 'brand' : 'red' }, titleize(t(sluggify(bankAccountVerificationStatus)))),
                    remark && (React.createElement("p", { className: "text-red-500 text-xs italic" }, remark)))))));
    }
    renderDocumentUpload(document_type) {
        const { t } = this.props;
        const isAlreadyUploaded = this.checkIsDocumentUploaded(document_type);
        const isActiveDocumentRejected = this.checkIsActiveDocumentRejected(document_type);
        const defaultUploadButtonClassNames = 'w-full h-24 mt-4 p-2.5 border-gray-300 border-dashed border-2 rounded text-gray-400';
        const erroredUploadButtonClassNames = 'w-full h-24 mt-4 p-2.5 border-red-500 border-dashed border-2 rounded text-red-500';
        let spanClassnames = '';
        if (isAlreadyUploaded && isActiveDocumentRejected.length > 0) {
            spanClassnames = 'text-red-500';
        }
        else if (isAlreadyUploaded && isActiveDocumentRejected.length === 0) {
            spanClassnames = 'text-teal-600';
        }
        else {
            spanClassnames = '';
        }
        const { errors, is_partner_with_factoring_company } = this.state;
        let displayText = '';
        switch (document_type) {
            case 'w9':
                displayText = 'UPLOAD_W9';
                break;
            case 'voided_check':
                displayText = 'UPLOAD_VOIDED_CHECK_OR_BANKS_LETTER';
                break;
            default:
                displayText = 'UPLOAD_NOTICE_OF_ASSIGNMENT_TEXT';
                break;
        }
        if (isAlreadyUploaded)
            displayText = 're '.concat(displayText);
        if (!is_partner_with_factoring_company &&
            document_type === 'notice_of_assignment')
            return null;
        return (React.createElement("div", null,
            React.createElement(Dropzone, { className: errors[document_type] && errors[document_type].length > 0
                    ? erroredUploadButtonClassNames
                    : defaultUploadButtonClassNames, onDrop: this.handleDocumentUpload(document_type), multiple: true, accept: BILLING_FILE_TYPES[document_type] },
                React.createElement("div", { className: spanClassnames }, t('CLICK_OR_DRAG_TO_ACTION', {
                    displayText: t(sluggify(displayText)),
                }))),
            React.createElement(ErrorLabel, { className: "mt-1" }, errors[document_type]),
            isActiveDocumentRejected.length > 0 && (React.createElement(ErrorLabel, { className: "mt-1" }, `${t('REJECTED')} : ${isActiveDocumentRejected}`))));
    }
    renderBankInfo() {
        const { errors, account, routing } = this.state;
        const hasBankAccountInfo = this.hasBankAccount();
        const shouldShowBankAccountInfo = this.hasBankAccountEntry();
        if (hasBankAccountInfo && !this.state.showBankForm) {
            return null;
        }
        return (React.createElement("div", null, !hasBankAccountInfo && (React.createElement(React.Fragment, null,
            React.createElement("legend", { className: "flex items-center border-b border-gray-200 border-solid space-x-2" },
                React.createElement("span", { className: "block my-0" }, this.props.t('ACCOUNT_INFO'))),
            !shouldShowBankAccountInfo && (React.createElement("div", { className: "grid sm:grid-cols-2 sm:gap-x-4 gap-y-4" },
                React.createElement(CargomaticInput, { label: `${this.props.t('ACCOUNT_NUMBER')}*`, value: account, placeholder: this.props.t('ACCOUNT_NUMBER'), onChange: this.getHandleChange('account'), error: { message: errors.account } }),
                React.createElement(CargomaticInput, { label: `${this.props.t('ROUTING_NUMBER')}*`, value: routing, placeholder: this.props.t('ROUTING_NUMBER'), onChange: this.getHandleChange('routing'), error: { message: errors.routing } }))),
            React.createElement("div", { className: "mt-4" },
                this.renderDocumentUpload('w9'),
                this.renderDocumentUpload('voided_check'),
                this.renderDocumentUpload('notice_of_assignment'))))));
    }
    renderPreviewConfirmationModalBody() {
        const files = this.state.previewFiles || [];
        return (React.createElement("div", null, files.map((file, index) => {
            let fileType = file.type;
            if (isPDF(fileType)) {
                return (React.createElement("div", { key: index },
                    React.createElement(PDFViewer, { file: file.preview, pdfStyle: {
                            maxWidth: '100%',
                        } })));
            }
            return (React.createElement("div", { key: index },
                React.createElement("img", { width: "100%", height: "100%", alt: "Preview", src: file.preview || '' })));
        })));
    }
    renderPreviewConfirmationModalFooter() {
        const { t } = this.props;
        return (React.createElement("div", { className: "flex gap-x-4 justify-end" },
            React.createElement("button", { className: "button", onClick: () => this.setState({ previewFiles: [], showPreviewModal: false }) }, t('REDO')),
            React.createElement("button", { className: "button button-green", onClick: () => this.handleDocumentSave() }, t('SAVE'))));
    }
    renderThankingModalBody() {
        const { t } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "font-bold" }, `${t('BANK_INFO_SUMBIT_GREETINGS')}.`),
            React.createElement("p", null, t('CARGOMATIC_TEAM_REVIEW_MSG'))));
    }
    renderThankingModalFooter() {
        const { t } = this.props;
        return (React.createElement("div", { className: "flex justify-end" },
            React.createElement("button", { onClick: () => this.handleHideThankingModal(), className: "button button-green" }, t('CLOSE'))));
    }
    renderCompanyOwner() {
        const { stripe_verification: { status: verificationStatus }, } = this.state;
        const verified = this.isVerified();
        const { first_name, last_name, month, day, year, errors } = this.state;
        const hasBankAccountInfo = this.hasBankAccountEntry();
        if (hasBankAccountInfo) {
            return null;
        }
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement("legend", { className: "flex items-center border-b border-gray-200 border-solid space-x-2" },
                React.createElement("span", { className: "block my-0" }, t('COMPANY_OWNER')),
                verificationStatus && (React.createElement(Badge, { color: verified ? 'brand' : 'red' }, titleize(verificationStatus)))),
            React.createElement("div", { className: "grid grid-cols-6 gap-4" },
                React.createElement("div", { className: "col-span-full sm:col-span-3" },
                    React.createElement(CargomaticInput, { label: `${t('FIRST_NAME')}*`, placeholder: t('FIRST_NAME'), value: first_name, onChange: this.getHandleChange('first_name'), error: { message: errors.first_name } })),
                React.createElement("div", { className: "col-span-full sm:col-span-3" },
                    React.createElement(CargomaticInput, { label: `${t('LAST_NAME')}*`, placeholder: t('LAST_NAME'), value: last_name, onChange: this.getHandleChange('last_name'), error: { message: errors.last_name } })),
                React.createElement("div", { className: "col-span-2" },
                    React.createElement(CargomaticInput, { type: "select", label: `${this.props.t('BIRTH_MONTH')}*`, placeholder: "Month", value: month, onChange: this.getHandleChange('month'), error: { message: errors.month }, valueKey: "value", textKey: "text", items: Months })),
                React.createElement("div", { className: "col-span-2" },
                    React.createElement(CargomaticInput, { label: `${this.props.t('DAY', { count: 1 })}*`, type: "number", min: 1, max: 31, step: 1, placeholder: "Day", value: day, onChange: this.getHandleChange('day'), error: { message: errors.day } })),
                React.createElement("div", { className: "col-span-2" },
                    React.createElement(CargomaticInput, { label: `${this.props.t('YEAR', { count: 1 })}*`, type: "number", step: 1, placeholder: "Year", value: year, onChange: this.getHandleChange('year'), error: { message: errors.year } })))));
    }
    renderCompanyInfo() {
        const { errors, business_type, business_tax_id, business_name, personal_id_number, is_partner_with_factoring_company, factoring_company_name, } = this.state;
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement("legend", { className: "" }, t('COMPANY_INFO')),
            React.createElement("div", { controlId: "business_type", validationState: this.getValidationState('business_type') },
                React.createElement("label", { className: "mb-1 form-label" }, `${t('BUSINESS_TYPE')}*`),
                React.createElement("div", { className: "space-y-1" },
                    React.createElement(OverlayTrigger, { placement: "top", overlay: CompanyTooltip },
                        React.createElement("div", { className: "userDetailValue" },
                            React.createElement(CargomaticRadio, { id: businessTypes.COMPANY, name: "business_type", value: businessTypes.COMPANY, checked: business_type === businessTypes.COMPANY, onChange: this.getHandleChange('business_type') }, this.props.t('BUSINESS_TYPE_COMPANY')))),
                    React.createElement(OverlayTrigger, { placement: "top", overlay: IndividualTooltip },
                        React.createElement("div", { className: "userDetailValue" },
                            React.createElement(CargomaticRadio, { id: businessTypes.INDIVIDUAL, name: "business_type", value: businessTypes.INDIVIDUAL, checked: business_type === businessTypes.INDIVIDUAL, onChange: this.getHandleChange('business_type') }, t('BUSINESS_TYPE_INDIVIDUAL')))))),
            business_type === businessTypes.COMPANY && (React.createElement("div", { className: "mt-4 grid sm:grid-cols-2 sm:gap-4" },
                React.createElement(CargomaticInput, { type: "password", label: t('EIN'), value: business_tax_id, onChange: this.handleEINChange, placeholder: t('EIN'), error: { message: errors.business_tax_id } }),
                React.createElement(CargomaticInput, { type: "text", label: t('BUSINESS_NAME'), value: business_name, placeholder: t('BUSINESS_NAME'), onChange: this.getHandleChange('business_name'), error: { message: errors.business_name } }))),
            business_type === businessTypes.INDIVIDUAL && (React.createElement("div", { className: "mt-4 grid sm:grid-cols-2 sm:gap-4" },
                React.createElement(CargomaticInput, { label: `${t('SSN')}*`, type: "password", placeholder: `${t('SSN')}: XXXXXXXXX`, value: personal_id_number, onChange: this.getHandleChange('personal_id_number'), error: { message: errors.personal_id_number } }))),
            React.createElement("div", { className: "mt-4" },
                React.createElement(CargomaticInput, { id: "is_partner_with_factoring_company", type: "checkbox", label: t('PARTNER_WITH_FACTORING_COMPANY'), value: is_partner_with_factoring_company, checked: is_partner_with_factoring_company, onChange: this.getHandleChange('is_partner_with_factoring_company') }),
                React.createElement(CargomaticInput, { type: "text", value: factoring_company_name, placeholder: t('ENTER_FACTORING_COMPANY_NAME'), disabled: !is_partner_with_factoring_company, onChange: this.getHandleChange('factoring_company_name'), error: { message: errors.factoring_company_name } }))));
    }
    renderAddress() {
        if (!this.isPendingOrVerified()) {
            return null;
        }
        const { t } = this.props;
        const { business_type } = this.state;
        const sectionHeading = business_type === businessTypes.COMPANY
            ? t('COMPANY_ADDRESS')
            : t('PERSONAL_ADDRESS');
        return (React.createElement("div", null,
            React.createElement("legend", { className: "" }, sectionHeading),
            React.createElement("div", { className: "grid grid-cols-6 gap-4" },
                React.createElement("div", { className: "col-span-full", controlId: "line1", validationState: this.getValidationState('line1') },
                    React.createElement(CargomaticInput, { placeholder: "Street", label: "Street", value: this.state.line1, onChange: this.getHandleChange('line1') })),
                React.createElement("div", { className: "col-span-full", controlId: "line2", validationState: this.getValidationState('line2') },
                    React.createElement(CargomaticInput, { placeholder: "Street 2", label: "Street 2", value: this.state.line2, onChange: this.getHandleChange('line2') })),
                React.createElement("div", { className: "col-span-2", controlId: "city", validationState: this.getValidationState('city') },
                    React.createElement(CargomaticInput, { placeholder: "City", label: "City", value: this.state.city, onChange: this.getHandleChange('city') })),
                React.createElement("div", { className: "col-span-2", controlId: "state", validationState: this.getValidationState('state') },
                    React.createElement(CargomaticInput, { placeholder: "State", label: "State", value: this.state.state, onChange: this.getHandleChange('state') })),
                React.createElement("div", { className: "col-span-2", controlId: "postal_code", validationState: this.getValidationState('postal_code') },
                    React.createElement(CargomaticInput, { placeholder: "Zipcode", label: "Zipcode", value: this.state.postal_code, onChange: this.getHandleChange('postal_code') })))));
    }
    render() {
        const { t } = this.props;
        const actions = (React.createElement("div", { className: "form-actions" },
            React.createElement("button", { className: "button button-green", onClick: this.handleSubmit }, t('SAVE_BANKING_INFORMATION'))));
        return (React.createElement(React.Fragment, null,
            React.createElement(Container, null,
                React.createElement("div", { className: "lg:grid lg:grid-cols-12 lg:gap-6 mt-10" },
                    React.createElement("div", { className: "lg:col-span-3 space-y-4" },
                        React.createElement(Sidebar, { activePage: "billing" }),
                        React.createElement("div", { className: "px-4" }, renderAccessorialDownloads())),
                    React.createElement("div", { className: "lg:col-span-6" },
                        React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
                            React.createElement(CargomaticCard, { header: () => this.renderBankingHeader(), grayFooter: true, footer: () => actions },
                                React.createElement("div", { className: "space-y-6" },
                                    this.renderSuccessMessage(),
                                    this.renderErrors(),
                                    this.renderBankInfoSummary(),
                                    this.renderCompanyOwner(),
                                    this.renderCompanyInfo(),
                                    this.renderAddress(),
                                    this.renderBankInfo()))),
                        React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.US] },
                            React.createElement(PaymentTerms, { data: this.getPaymentTermsData(), className: "mb-4", onUpdateShipper: this.onSaveCarrier, overwritePaymentTermsSlugs: true }))))),
            React.createElement(CargomaticModal, { show: this.state.showPreviewModal, title: t('CONFIRM_DOCUMENT_VERIFICATION'), onHide: () => this.handleHidePreviewConfirmationModal(), body: this.renderPreviewConfirmationModalBody(), footer: this.renderPreviewConfirmationModalFooter() }),
            React.createElement(CargomaticModal, { show: this.state.showThankingModal, title: t('BANKING_INFORMATION'), onHide: () => this.handleHideThankingModal(), body: this.renderThankingModalBody(), footer: this.renderThankingModalFooter() })));
    }
}
export default withTranslation()(Billing);
